import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    
    return (
        <div>
           

  <Navbar collapseOnSelect expand="lg" className="navbar-background" variant="dark">
  <Container>
  <Navbar.Brand  ><Link className="header-text text-warning fw-bold fs-1" to="/home">Portfolio</Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="me-auto">
       <Nav.Link ><Link  to="/home" className="header-text ">Home</Link></Nav.Link>
        <Nav.Link ><Link  to="/blogs" className="header-text ">Blogs</Link></Nav.Link>

        <Nav.Link><Link  to="/aboutMe" className="header-text">About Me</Link></Nav.Link>
        
        <Nav.Link ><Link  to="/contactMe" className="header-text">Contact Me</Link></Nav.Link>
    </Nav>
  </Navbar.Collapse>
  </Container>
</Navbar>
        </div>
    );
};

export default Header;